import { useState, useCallback, useEffect, useLayoutEffect } from "react";
const useDragContainer = (ref, containerRef, sensitivity = 10) => {
  var _a, _b;
  const [isDragging, setIsDragging] = useState(false);
  const [startingPosition, setStartingPosition] = useState(0);
  const handleMouseMove = useCallback(
    (event) => {
      const element = (containerRef == null ? void 0 : containerRef.current) ?? (ref == null ? void 0 : ref.current);
      const updatedPosition = startingPosition - event.pageX;
      if (element)
        element.scrollLeft += updatedPosition / sensitivity;
    },
    [startingPosition]
  );
  const handleMouseDown = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      setIsDragging(true);
      setStartingPosition(event.pageX);
    },
    [startingPosition]
  );
  const handleMouseUp = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      setIsDragging(false);
      setStartingPosition(0);
    },
    [startingPosition]
  );
  useEffect(() => {
    if (ref.current) {
      ref.current.style.cursor = "grab";
      ref.current.style.userSelect = "none";
    }
  }, []);
  useEffect(() => {
    var _a2, _b2;
    if (isDragging) {
      (_a2 = ref.current) == null ? void 0 : _a2.addEventListener("mousemove", handleMouseMove);
      window.document.addEventListener("mouseup", handleMouseUp);
    } else {
      (_b2 = ref.current) == null ? void 0 : _b2.removeEventListener("mousemove", handleMouseMove);
      window.document.removeEventListener("mouseup", handleMouseUp);
    }
    return () => {
      var _a3;
      (_a3 = ref.current) == null ? void 0 : _a3.removeEventListener("mousemove", handleMouseMove);
      window.document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [startingPosition]);
  useLayoutEffect(() => {
    var _a2;
    (_a2 = ref.current) == null ? void 0 : _a2.addEventListener("mousedown", handleMouseDown);
    return () => {
      var _a3;
      (_a3 = ref.current) == null ? void 0 : _a3.removeEventListener("mousedown", handleMouseDown);
    };
  }, [(_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.offsetHeight, (_b = ref == null ? void 0 : ref.current) == null ? void 0 : _b.offsetWidth, startingPosition]);
  return {
    isDragging
  };
};
export {
  useDragContainer
};
